import { render, staticRenderFns } from "./SectionStatistics.vue?vue&type=template&id=24a31aec&scoped=true&"
import script from "./SectionStatistics.vue?vue&type=script&lang=js&"
export * from "./SectionStatistics.vue?vue&type=script&lang=js&"
import style0 from "./SectionStatistics.vue?vue&type=style&index=0&id=24a31aec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a31aec",
  null
  
)

export default component.exports